<template>
  <div class="bg-body rounded p-5 pb-3 mb-5">
    <div class="d-flex align-items-center mb-3">
      <h4 class="align-items-start flex-column fw-bold text-gray-900 m-0 ms-2">
        {{ this.$route.meta.title || 'Страница' }}
        <span class="text-muted fw-normal fs-6">- Уведомления</span>
      </h4>
      <slot name="create"></slot>
    </div>
    <div class="btn-custom-white d-flex ms-1 mb-2" role="group">
      <button type="button" @click="goToPage('NotificationTemplate')" :class="this.$route.name === 'NotificationTemplate' ? 'btn-success' : 'bg-secondary'" class="btn btn-sm me-2 mb-2">Шаблоны</button>
      <button type="button" @click="goToPage('NotificationSchedule')" :class="this.$route.name === 'NotificationSchedule' ? 'btn-success' : 'bg-secondary'" class="btn btn-sm me-2 mb-2">Запланированные уведомления</button>
      <button type="button" @click="goToPage('NotificationTopic')" :class="this.$route.name === 'NotificationTopic' ? 'btn-success' : 'bg-secondary'" class="btn btn-sm me-2 mb-2">Топики</button>
      <button type="button" @click="goToPage('NotificationCategory')" :class="this.$route.name === 'NotificationCategory' ? 'btn-success' : 'bg-secondary'" class="btn btn-sm me-2 mb-2">Категории</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotificationHeaderList',
  data() {
    return {
      showGrantModal: false,
    }
  },
  methods: {
    goToPage(page) {
      this.$router.push({ name: page });
    },
  },
}
</script>

<style scoped>

</style>